const DevAvatarAnimation = () => {
  return (
    <div className="flex flex-col items-center gap-0">
      <svg
        width="80"
        height="90"
        viewBox="0 0 420 470"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Developer avatar"
        className="opacity-90"
      >
        <style>{`
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-14px); }
          }
          @keyframes floatA {
            0%, 100% { transform: translateY(0px) rotate(-4deg); }
            50% { transform: translateY(-12px) rotate(4deg); }
          }
          @keyframes floatB {
            0%, 100% { transform: translateY(0px) rotate(3deg); }
            50% { transform: translateY(-9px) rotate(-3deg); }
          }
          @keyframes floatC {
            0%, 100% { transform: translateY(0px) rotate(-2deg); }
            50% { transform: translateY(-11px) rotate(2deg); }
          }
          @keyframes blink {
            0%, 100% { opacity: 1; }
            48%, 52% { opacity: 0; }
          }
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          @keyframes glow {
            0%, 100% { opacity: 0.07; }
            50% { opacity: 0.18; }
          }
          @keyframes dotPulse {
            0%, 100% { opacity: 0.4; transform: scale(1); }
            50% { opacity: 1; transform: scale(1.4); }
          }
          .av-figure { animation: float 4s ease-in-out infinite; }
          .av-tag-div { animation: floatA 3.6s ease-in-out infinite 0s; transform-box: fill-box; transform-origin: center; }
          .av-tag-close { animation: floatB 4.1s ease-in-out infinite 0.4s; transform-box: fill-box; transform-origin: center; }
          .av-tag-brace { animation: floatC 3.3s ease-in-out infinite 0.9s; transform-box: fill-box; transform-origin: center; }
          .av-tag-hash { animation: floatA 3.8s ease-in-out infinite 1.3s; transform-box: fill-box; transform-origin: center; }
          .av-tag-cursor { animation: floatB 4.4s ease-in-out infinite 0.7s; transform-box: fill-box; transform-origin: center; }
          .av-cursor-blink { animation: blink 1.1s step-end infinite; }
          .av-orbit-ring { animation: spin 12s linear infinite; transform-origin: 210px 215px; }
          .av-glow-bg { animation: glow 3.5s ease-in-out infinite; }
          .av-dot1 { animation: dotPulse 2.1s ease-in-out infinite 0s; transform-box: fill-box; transform-origin: center; }
          .av-dot2 { animation: dotPulse 2.4s ease-in-out infinite 0.5s; transform-box: fill-box; transform-origin: center; }
          .av-dot3 { animation: dotPulse 2.8s ease-in-out infinite 1.1s; transform-box: fill-box; transform-origin: center; }
          .av-dot4 { animation: dotPulse 1.9s ease-in-out infinite 0.3s; transform-box: fill-box; transform-origin: center; }
          .av-dot5 { animation: dotPulse 2.6s ease-in-out infinite 1.4s; transform-box: fill-box; transform-origin: center; }
        `}</style>

        <ellipse className="av-glow-bg" cx="210" cy="235" rx="178" ry="168" fill="#24aec7"/>

        <g className="av-orbit-ring">
          <circle cx="210" cy="215" r="168" fill="none" stroke="#8bb1d6" strokeWidth="1.8" strokeDasharray="12 8" opacity="0.5"/>
          <circle cx="210" cy="47" r="6" fill="#e3833a" opacity="0.9"/>
        </g>

        <g className="av-figure">
          <path d="M128 400 Q126 315 148 306 Q178 294 210 298 Q242 294 272 306 Q294 315 292 400 Z" fill="#1a1a2e"/>
          <path d="M128 400 Q126 330 148 316 Q168 307 185 305 L185 400 Z" fill="#111124" opacity="0.5"/>
          <path d="M183 303 L210 342 L237 303" fill="none" stroke="#24aec7" strokeWidth="3.8" strokeLinejoin="round" strokeLinecap="round"/>
          <path d="M183 303 Q195 322 210 342" fill="none" stroke="#1e90b0" strokeWidth="1.5" opacity="0.7"/>
          <path d="M237 303 Q225 322 210 342" fill="none" stroke="#1e90b0" strokeWidth="1.5" opacity="0.7"/>

          <rect x="193" y="272" width="34" height="36" rx="13" fill="#7B4020"/>
          <rect x="193" y="272" width="10" height="36" rx="8" fill="#5C2E10" opacity="0.35"/>

          <ellipse cx="210" cy="248" rx="66" ry="70" fill="#7B4020"/>
          <ellipse cx="238" cy="258" rx="16" ry="12" fill="#8B4C28" opacity="0.45"/>
          <ellipse cx="166" cy="252" rx="18" ry="30" fill="#5C2E10" opacity="0.3"/>

          <ellipse cx="210" cy="188" rx="70" ry="52" fill="#100808"/>
          <circle cx="153" cy="215" r="34" fill="#100808"/>
          <circle cx="267" cy="215" r="34" fill="#100808"/>
          <circle cx="210" cy="173" r="42" fill="#100808"/>
          <ellipse cx="210" cy="207" rx="68" ry="26" fill="#100808"/>
          <ellipse cx="190" cy="168" rx="12" ry="8" fill="#1e1010" opacity="0.6"/>
          <ellipse cx="232" cy="172" rx="10" ry="7" fill="#1e1010" opacity="0.6"/>
          <ellipse cx="158" cy="210" rx="8" ry="10" fill="#1e1010" opacity="0.5"/>
          <ellipse cx="264" cy="208" rx="8" ry="10" fill="#1e1010" opacity="0.5"/>

          <ellipse cx="145" cy="254" rx="12" ry="16" fill="#6B3818"/>
          <ellipse cx="145" cy="254" rx="7" ry="10" fill="#7B4020"/>
          <ellipse cx="275" cy="254" rx="12" ry="16" fill="#6B3818"/>
          <ellipse cx="275" cy="254" rx="7" ry="10" fill="#7B4020"/>

          <path d="M172 226 Q188 219 202 224" fill="none" stroke="#100808" strokeWidth="4" strokeLinecap="round"/>
          <path d="M218 224 Q232 219 248 226" fill="none" stroke="#100808" strokeWidth="4" strokeLinecap="round"/>

          <ellipse cx="188" cy="245" rx="15" ry="13" fill="#5C2E10"/>
          <ellipse cx="232" cy="245" rx="15" ry="13" fill="#5C2E10"/>
          <circle cx="188" cy="245" r="10" fill="#0d0d0d"/>
          <circle cx="232" cy="245" r="10" fill="#0d0d0d"/>
          <circle cx="188" cy="245" r="6" fill="#2a1506"/>
          <circle cx="232" cy="245" r="6" fill="#2a1506"/>
          <circle cx="192" cy="241" r="4" fill="white" opacity="0.88"/>
          <circle cx="236" cy="241" r="4" fill="white" opacity="0.88"/>
          <circle cx="193" cy="240" r="1.8" fill="white"/>
          <circle cx="237" cy="240" r="1.8" fill="white"/>

          <rect x="164" y="233" width="38" height="26" rx="7" fill="none" stroke="#e3833a" strokeWidth="3.2"/>
          <rect x="208" y="233" width="38" height="26" rx="7" fill="none" stroke="#e3833a" strokeWidth="3.2"/>
          <rect x="164" y="233" width="38" height="26" rx="7" fill="#e3833a" opacity="0.07"/>
          <rect x="208" y="233" width="38" height="26" rx="7" fill="#e3833a" opacity="0.07"/>
          <line x1="202" y1="246" x2="208" y2="246" stroke="#e3833a" strokeWidth="3.2" strokeLinecap="round"/>
          <line x1="144" y1="246" x2="164" y2="246" stroke="#e3833a" strokeWidth="2.6" strokeLinecap="round"/>
          <line x1="246" y1="246" x2="275" y2="246" stroke="#e3833a" strokeWidth="2.6" strokeLinecap="round"/>

          <path d="M205 260 Q210 274 215 260" fill="none" stroke="#5C2A0E" strokeWidth="2.2" strokeLinecap="round"/>
          <ellipse cx="204" cy="271" rx="5" ry="4" fill="#6B3818"/>
          <ellipse cx="216" cy="271" rx="5" ry="4" fill="#6B3818"/>
          <line x1="210" y1="258" x2="210" y2="264" stroke="#5C2A0E" strokeWidth="1.5" strokeLinecap="round"/>

          <path d="M192 285 Q210 298 228 285" fill="none" stroke="#5C2A0E" strokeWidth="2.8" strokeLinecap="round"/>
        </g>

        <g className="av-tag-div">
          <rect x="18" y="160" width="88" height="40" rx="10" fill="#24aec7"/>
          <text x="62" y="186" textAnchor="middle" fontFamily="'Courier New',monospace" fontSize="15" fontWeight="bold" fill="white">&lt;div&gt;</text>
        </g>

        <g className="av-tag-close">
          <rect x="312" y="140" width="82" height="40" rx="10" fill="#e3833a"/>
          <text x="353" y="166" textAnchor="middle" fontFamily="'Courier New',monospace" fontSize="16" fontWeight="bold" fill="white">/&gt;</text>
        </g>

        <g className="av-tag-brace">
          <rect x="16" y="318" width="65" height="40" rx="10" fill="#8bb1d6"/>
          <text x="48" y="344" textAnchor="middle" fontFamily="'Courier New',monospace" fontSize="17" fontWeight="bold" fill="white">{"{ }"}</text>
        </g>

        <g className="av-tag-hash">
          <rect x="318" y="96" width="52" height="40" rx="10" fill="#24aec7" opacity="0.9"/>
          <text x="344" y="122" textAnchor="middle" fontFamily="'Courier New',monospace" fontSize="20" fontWeight="bold" fill="white">#</text>
        </g>

        <g className="av-tag-cursor">
          <rect x="328" y="336" width="58" height="40" rx="10" fill="#1a1a2e"/>
          <text x="357" y="362" textAnchor="middle" fontFamily="'Courier New',monospace" fontSize="17" fontWeight="bold" fill="#24aec7" className="av-cursor-blink">_</text>
        </g>

        <circle className="av-dot1" cx="108" cy="128" r="6" fill="#e3833a" opacity="0.8"/>
        <circle className="av-dot2" cx="56" cy="280" r="5" fill="#24aec7" opacity="0.7"/>
        <circle className="av-dot3" cx="318" cy="410" r="5" fill="#8bb1d6" opacity="0.7"/>
        <circle className="av-dot4" cx="358" cy="290" r="4" fill="#e3833a" opacity="0.7"/>
        <circle className="av-dot5" cx="72" cy="415" r="4" fill="#24aec7" opacity="0.6"/>
      </svg>
      <p className="text-xs text-muted-foreground">
        <span className="font-semibold text-primary">Mindset Solutions Africa</span>
      </p>
    </div>
  );
};

export default DevAvatarAnimation;
